import Text from "components/ui/Text";
import * as style from "./Top.styles";
import Close from "static-file/images/close.png";
import { overlay } from "overlay-kit";
import { AlertModal } from "components/modal/AlertModal";
import { useHistory } from "react-router-dom";

interface Props {
  title: string;
}

export const NaverTop = ({ title }: Props) => {
  const history = useHistory();

  const handleClose = () => {
    overlay.open(({ isOpen, close }) => (
      <AlertModal
        open={isOpen}
        onClose={close}
        title="연동을 중지하시겠어요?"
        subTit1="지금 이 페이지를 나가시면"
        subTit2="이후에는 처음부터 다시 시작해야해요."
        leftBtnOnClick={close}
        leftBtnVariant="secondaryPrimary"
        leftBtnTxt="취소"
        rightBtnOnClick={() => {
          close();
          window.location.href = "/setting/default/receipt";
        }}
        rightBtnTxt="나가기"
        rightBtnVariant="secondaryError"
      />
    ));
  };

  return (
    <>
      <style.Container>
        <img src={Close} alt="close" onClick={handleClose} />
        <Text fontSize={17} fontWeight={600} color="#3F3F46">
          {title}
        </Text>
      </style.Container>
      <style.Line />
    </>
  );
};
